export const LOGIN_USER_SUCCESSFULL = "LOGIN_USER_SUCCESSFULL"
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const ERROR_MESSAGE = "ERROR_MESSAGE"
export const ERROR_CLEAR_MESSAGE = "ERROR_CLEAR_MESSAGE"
export const MAKING_REQUEST = "MAKING_REQUEST"
export const REQUEST_COMPLETED = "REQUEST_COMPLETED"
export const LOG_OUT = "LOG_OUT"
export const LOAD_USER = "LOAD_USER"
 